import React, { useState,useContext, useEffect } from "react";
import { ButtonLoader } from "../../../utils/Loaders/ButtonLoader";
import {useFetch} from "../../../api/FetchApiData";
import { MediaUrl } from "../../../utils/media/Media";
import { isMobile, MobileView } from "react-device-detect";
import { UserContext } from "../../../../AppContextProvider";
import { useTranslation } from "react-i18next";
if (isMobile)
    import('./charge_mob.css').then(() => {});
else
    import('./charge.css').then(() => {});


export default function Charge({is_new=false,AddToHomeCharges=()=>{},charge={name:'Nouveau composant',power:1000,duration:8,night_use:true,quantity:1,image:null}})
{
    const [_charge,setCharge] = useState({...charge,quantity:1});
    const [btnDetails,setBtnDetails] = useState({display:'none',text:'+'});
    const [loadState,setLoadState] = useState({loading:false,backGroundColor:'lightblue'});
    const fetchData = useFetch();
    const [UserState,setUserState] = useContext(UserContext);
    const {t} = useTranslation();

    let btnAddValue = "Ajouter";
    let backGroundBtnAdd = "skyblue";

    const _AddToHomeCharges = ()=>
    {
        AddToHomeCharges(_charge);
    };

    const StoreNewCharge = ()=>
    {
        setLoadState({...loadState,loading:true});
        let _charge_ = _charge;
        var formdata = new FormData();
        if(!!_charge_.image)
            formdata.append('image',_charge_.image,_charge_.image.name)
        delete _charge_.image;
        formdata.append('data',JSON.stringify(_charge_))
        fetchData.PostFormData(formdata,'pvcharge/').then((result)=>{
            setLoadState({...loadState,loading:false});
        }) 
    }

    const UpdateCharge = ()=>
    {
        setLoadState({...loadState,loading:true});
        let _charge_ = _charge;
        var formdata = new FormData();
        if(!!_charge_.image)
            formdata.append('image',_charge_.image,_charge_.image.name)
        delete _charge_.image;
        formdata.append('data',JSON.stringify(_charge_))
        fetchData.PutFormData(formdata,'pvcharge/').then((result)=>{
            console.log(result);
            setLoadState({...loadState,loading:false});
        }) 
    }

    const DeleteCharge = ()=>
    {
        setLoadState({...loadState,loading:true});
        fetchData.DeleteData({id:_charge.id},'pvcharge/').then((result)=>{
            console.log(result);
            setLoadState({...loadState,loading:false});
        }) 
    }

    

    const SubmitButton = ()=>
    {
        if(!is_new)
        {
            return (<div>
                    <input onClick={e=>{_AddToHomeCharges()}} type="button" id="btnAdd" value={btnAddValue} style={{backgroundColor:backGroundBtnAdd,width:'50%'}} />
                </div>
            );
        }
        else
        {
            return (  
                <div>
                    <input type="file" id="ChargeInputImage" onChange={e=>{setCharge({..._charge,image:e.target.files[0]});}} multiple={false} style={{display:'none'}} />
                    <input type="button" value={'Image'} style={{width:'100px',display:'inline-block',backgroundColor:'lightgray',color:'black',height:'25px',marginRight:'10px',verticalAlign:'middle',border:'none',borderRadius:'5px'}} onClick={e=>{document.getElementById("ChargeInputImage").click()}} />
                    <div style={{height:'25px',width:'100px',borderRadius:'5px',display:'inline-block',margin:'auto',marginTop:'5px',verticalAlign:'middle'}}>
                            <ButtonLoader style={{backGroundColor:'skyblue',fontSize:'small',color:'black'}}  onSubmit={()=>{StoreNewCharge()}} text={"Créer"} loading={loadState.loading} disabled={false} />
                    </div>
                </div>);
        }
    }

    const imgSrc = ()=>
    {
        try
        {
            return URL.createObjectURL(_charge.image);
        }
        catch{
            if(!!_charge.image)
                return MediaUrl(_charge.image.image);
            else
                return null
        }
    }

    const OnclickDetails = ()=>{
        if(btnDetails.display==='none')
            setBtnDetails({display:'block',text:'-'});
        else
            setBtnDetails({display:'none',text:'+'});
    }

    let mob_image = {disp:'none',controls_width:"95%"};
    if(isMobile && !!_charge.image)
        mob_image = {disp:'inline-block',controls_width:"70%"};

    return(
        <div id="Charge">
            <div style={{marginBottom:'0px',borderRadius:'5px',width:'100%',height:'25px',display:'inline-flex',flexDirection:'row',justifyContent:'center',alignItems:'center',border:'1px solid lightgray'}}>
                <input type="button" onClick={e=>OnclickDetails()} value={btnDetails.text} className="charge-btn-details" />
                {<input style={{backgroundColor:'whitesmoke'}} className="charge-title-input"  disabled={!UserState.is_staff} onChange={e=>{setCharge({..._charge,name:e.target.value})}} type="text" value={_charge.name} />}
                { !is_new && <input onClick={e=>{_AddToHomeCharges()}}  type="button" value={t('filters.ajouter')} className="charge-btn-add" />}
            </div>
            <div style={{width:'100%',margin:'auto',textAlign:'center',display:btnDetails.display,borderRadius:'5px',backgroundColor:'whitesmoke'}}>
                <div className="charge-details" style={{width:'95%',display:'inline-block',verticalAlign:'middle'}}>
                    <div style={{margin:'5px'}}>
                        <label style={{verticalAlign:'middle',display:'inline-block',marginRight:'5px',fontSize:'xx-small'}}>{t('filters.nocturne')} : </label>
                        <input onChange={e=>{setCharge({..._charge,night_use:e.target.checked})}} checked={_charge.night_use} type="checkbox" style={{verticalAlign:'middle',display:'inline-block',width:'15px'}} /><br/>
                        <label style={{verticalAlign:'middle',display:'inline-block',marginLeft:'10px',fontSize:'xx-small'}}> {t('produit.quantite')} : </label>
                        <input id="charge-qty" type="number" style={{fontSize:'xx-small',verticalAlign:'middle',display:'inline-block',width:'40px',margin:'5px',textAlign:'center'}} onChange={e=>{setCharge({..._charge,quantity:Number(e.target.value)})}} value={_charge.quantity}/>
                    </div>
                    <div style={{marginTop:'10px',textAlign:'left'}}>
                        <label htmlFor="" style={{fontSize:'xx-small'}} className="labels" >{t('filters.duree')} : <span className="units">({_charge.duration} Heures)</span> </label>
                        <input style={{}} disabled={!_charge.night_use} type="range" onChange={e=>{setCharge({..._charge,duration:Number(e.target.value)})}} className="input-range" value={_charge.duration} step={1} min={0} max={24} />
                    </div>
                    <div style={{textAlign:'left'}}>
                        <label htmlFor="" style={{fontSize:'xx-small'}} className="labels" >{t('filters.puissance')} : <span className="units">({_charge.power} W)</span> </label>
                        <div style={{display:'inline-flex',flex:'row',justifyItems:'center',alignItems:'center',width:'100%'}}>
                            {/*<input onClick={e=>{setCharge({..._charge,power:_charge.power-1})}} type="button" value={'-'} style={{height:'22px',width:'30px',borderRadius:'3px',padding:'0px',margin:'2px',border:'none'}} />*/}
                            <input type="range" onChange={e=>{setCharge({..._charge,power:Number(e.target.value)})}} value={_charge.power} className="input-range" step={1} min={0} max={6000} />
                            {/*<input onClick={e=>{setCharge({..._charge,power:_charge.power+1})}} type="button" value={'+'} style={{height:'22px',width:'30px',borderRadius:'3px',padding:'0px',border:'none'}} />*/}
                        </div>
                    </div>
                    <div style={{paddingBottom:'10px'}}>
                        {
                            (is_new && UserState.is_staff &&
                            <div>
                                <input type="file" id="ChargeInputImage" onChange={e=>{setCharge({..._charge,image:e.target.files[0]});}} multiple={false} style={{display:'none'}} />
                                <input type="button" value={'Image'} style={{width:'60px',fontSize:'x-small',display:'inline-block',backgroundColor:'lightgray',color:'black',height:'25px',marginRight:'10px',verticalAlign:'middle',border:'none',borderRadius:'5px'}} onClick={e=>{document.getElementById("ChargeInputImage").click()}} />
                                <div style={{height:'25px',width:'60px',borderRadius:'5px',display:'inline-block',margin:'auto',marginTop:'5px',verticalAlign:'middle'}}>
                                        <ButtonLoader style={{backGroundColor:'skyblue',fontSize:'x-small',color:'black'}}  onSubmit={()=>{StoreNewCharge()}} text={"Créer"} loading={loadState.loading} disabled={false} />
                                </div>
                            </div>)
                        }
                        {
                            (!is_new && UserState.is_staff && 
                            <div style={{marginBottom:'10px'}}>
                                <div style={{height:'25px',width:'43%',borderRadius:'5px',display:'inline-block',margin:'auto',marginTop:'5px',marginRight:'10px',verticalAlign:'middle'}}>
                                        <ButtonLoader style={{backGroundColor:'orangered',fontSize:'xx-small',color:'black'}}  onSubmit={()=>{DeleteCharge()}} text={"Supprimer"} loading={loadState.loading} disabled={false} />
                                </div>
                                <div style={{height:'25px',width:'43%',borderRadius:'5px',display:'inline-block',margin:'auto',marginTop:'5px',verticalAlign:'middle'}}>
                                        <ButtonLoader style={{backGroundColor:'skyblue',fontSize:'xx-small',color:'black'}}  onSubmit={()=>{UpdateCharge()}} text={"Mettre à jour"} loading={loadState.loading} disabled={false} />
                                </div>
                            </div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}